export default {"src":"/_next/static/media/ongoing-review.99336e26.svg","height":198,"width":222,"blurWidth":0,"blurHeight":0};